import React from 'react';
import PropTypes from 'prop-types';
import isNumber from 'lodash/isNumber';

export const formatNumber = (number) => {
  if (!isNumber(number) || !isFinite(number)) return null;
  return number.toLocaleString('US', {
    style: 'decimal',
  });
};

const Num = ({ children, fallback, automationId }) => (
  <span data-automation-id={automationId}>
    {formatNumber(children) || fallback}
  </span>
);
Num.propTypes = {
  children: PropTypes.number,
  fallback: PropTypes.string,
  automationId: PropTypes.string,
};
Num.defaultProps = {
  children: null,
  fallback: '',
  automationId: null,
};
export default Num;
